module.exports = __webpack_public_path__ + "static/media/plus.aa922b9a.svg";